import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from './Navbar.js';
import Sidebar from './Sidebar.js';
import labService from './labService.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import './css/Lab.css';
import './css/ChooseModel.css';
import token_red from './images/token-red.png'
import token_green from './images/token_nqtb.png'
import Visualization from './Visualization.js';
import ModelsByCategory from './ModelsByCategory.js';


const ChooseModel = ({ isCollapsed, toggleSidebar }) => {
    const { endpointPk, analysisPk } = useParams();
    const [endpointDetails, setendpointDetails] = useState(null);
    const [modelsList, setModelsList] = useState([]);
    const [error, setError] = useState(null);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedModels, setSelectedModels] = useState({});
    const [expandedModels, setExpandedModels] = useState([]);
    const [analysisName, setAnalysisName] = useState('');
    const navigate = useNavigate();


    useEffect(() => {
        const token = JSON.parse(localStorage.getItem('user'))?.access;
        
        if (!token) {
            setError("You must be logged in to view this page.");
            return;
        }

        const fetchSelectModels = async () => {
            try {
                const response = await labService.getMLModelsByEndpoint(endpointPk, token);
                setModelsList(response.data);

            } catch (error) {
                console.error('Error fetching prediction details:', error);
                setError('Failed to fetch models. Please try again.');
            }
        };

        const fetchEndpointDetails = async () => {
            try {
                const response = await labService.getEndpointDetail(endpointPk, token);
                setendpointDetails(response.data);

            } catch (error) {
                console.error('Error fetching endpoint details:', error);
                setError('Failed to fetch endpoint. Please try again.');
            }
        };

        
        fetchEndpointDetails();
        fetchSelectModels();
    }, [endpointPk]);

    useEffect(() => {
        const fetchUserData = async () => {
            const userData = localStorage.getItem('user');
            if (!userData) {
                setLoading(false);
                return;
            }

            const parsedUserData = JSON.parse(userData);
            const token = parsedUserData.access;
            if (!token) {
                setLoading(false);
                return;
            }

            try {
                const response = await labService.getUserInfo(token);
                setUser(response.data);
            } catch (error) {
                console.error('Error fetching user data', error);
            } finally {
                setLoading(false);
            }
            
        };

        fetchUserData();
    }, []);

    const handleNext = () => {
        if (!selectedModels || Object.keys(selectedModels).length === 0) return;
        if (user && user.coins < totalCost) return;
        if (analysisName.trim() === '') return;

        localStorage.setItem('selectedModels', JSON.stringify(selectedModels));
        localStorage.setItem('analysisName', JSON.stringify(analysisName));

        const path = analysisPk ? `/new-pred/${analysisPk}` : '/new-pred';
        navigate(path);
    };

    
    const closeSelectModels = () => {
        navigate(-1);
    };

    const handleCheckboxChange = (modelId, cellLine) => {
        setSelectedModels((prev) => {
            const current = prev[modelId] || [];

            if (current.includes(cellLine)) {
                // remove it
                const updated = current.filter((cl) => cl !== cellLine);
                const newState = { ...prev, [modelId]: updated };
                if (updated.length === 0) delete newState[modelId]; // cleanup empty keys
                return newState;
            } else {
                // add it
                return { ...prev, [modelId]: [...current, cellLine] };
            }
        });
    };


    const totalCost = Object.entries(selectedModels).reduce((acc, [modelId, cellLines]) => {
        const model = modelsList.find(m => m.id === parseInt(modelId));
        return acc + (model ? model.model_price * cellLines.length : 0);
    }, 0);

    const toggleExpand = (modelId) => {
        setExpandedModels((prev) =>
            prev.includes(modelId) ? prev.filter((id) => id !== modelId) : [...prev, modelId]
        );
    };

    const getStaticUrl = (filename) => {
        // Assuming your Django backend is on port 8000 in development
        const backendUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
        return `${backendUrl}/static/qmrf/${filename}`;
    };

    // check/uncheck all cell lines for a model
    const handleAllCheckboxChange = (modelId, allCellLines) => {
        setSelectedModels((prev) => {
            const currentlySelected = prev[modelId] || [];
            const allSelected = allCellLines.every((cl) => currentlySelected.includes(cl));

            if (allSelected) {
                // unselect all
                const newState = { ...prev };
                delete newState[modelId];
                return newState;
            } else {
                // select all
                return { ...prev, [modelId]: allCellLines };
            }
        });
    };

    return (
        <div className='lab-container'>
            <Navbar />
            <div className='lab-side-content'>
                <Sidebar active_n={2} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
                <div className='new-pred-container'>
                    <div className='np-tabs'>
                        <div className='x'>
                            <button onClick={closeSelectModels} className='x-but'>
                                <FontAwesomeIcon className='icon-x' icon={faX} />
                            </button>
                        </div>
                        <div className='np-steps active-tab-cm'>
                            <p className='p-step'>STEP 1</p>
                            <p className='mar-btm-few'>Select endpoints</p>
                        </div>
                        <div className='np-steps'>
                            <p className='p-step'>STEP 2</p>
                            <p className='mar-btm-few'>Define Nanoform</p>
                        </div>
                        <div className='np-steps'>
                            <p className='p-step'>STEP 3</p>
                            <p className='mar-btm-few'>Summary</p>
                        </div>
                        <div className='np-steps'>
                            <p className='p-step'>STEP 4</p>
                            <p className='mar-btm-few'>Results</p>
                        </div>
                
                    </div>
                    
                        {endpointDetails && modelsList ? (
                            <div className='models-cont'>

                                <div className='upper-cp-vis'>
                                    <div className='control-panel'>
                                        <p className='end-p'>Analysis Name</p>
                                        <input
                                            className='nqtb-input'
                                            type="text"
                                            placeholder='max. 65 characters'
                                            value={analysisName}
                                            onChange={(e) => setAnalysisName(e.target.value)}
                                            maxLength={65}
                                        />
                                        <p className='end-p'>Endpoints</p>
                                        <div className='mdls-div'>
                                            
                                            <ModelsByCategory
                                            modelsList={modelsList}
                                            expandedModels={expandedModels}
                                            selectedModels={selectedModels}
                                            user={user}
                                            toggleExpand={toggleExpand}
                                            handleAllCheckboxChange={handleAllCheckboxChange}
                                            handleCheckboxChange={handleCheckboxChange}
                                            />

                                            <div className="btm-sel-mod">
                                                <div className="cost-div">
                                                    
                                                    <p className={`${user && user.coins < totalCost ? 'not-cost-sm' : 'cost-sm'}`}>
                                                        {`Total cost: ${totalCost} ${totalCost === 1 ? "token" : "tokens"}`}
                                                        <img
                                                            className="token-cost-sm"
                                                            src={user && user.coins < totalCost ? token_red : token_green}
                                                            alt="token icon"
                                                        />
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    
                                    <div className='visualization-area' style={{ flex: '2' }}>
                                        <Visualization
                                            core={{ name: 'TiO2' }}
                                            coreModification={null}
                                            coreColor="#b6b6b6" 
                                            surfaceFunctionalization={false}
                                            surfaceFunctionalizationColor="#9ed2ff"
                                            lineColor="#7fb13a"
                                            isNanoformImageGenerated={false}
                                            visualizationType={'inconclusive'}
                                        />
                                    </div>
                                </div>
                                
                                <div className='next-div'>
                                    {user && user.coins < totalCost ? (
                                        <div className="message-left">
                                            <p className="not-enough-tokens"><span className="boldy">You do not have enough tokens </span>to make this number of predictions. Go to the Wallet tab to top up your account.</p>
                                        </div>
                                    ) : (
                                        <div className="message-left placeholder"></div>
                                    )}

                                    <button onClick={handleNext} className={`${user && user.coins >= totalCost && totalCost > 0 && analysisName?.trim().length > 0 ? 'next-but-ready' : 'next-but'}`}>
                                        Next
                                    </button>
                                </div>
                        
                            </div>

                            

                        ): (<></>)}
                    
                    
                </div>    
            </div>
        </div>
    );
};

export default ChooseModel;